module.exports = __webpack_public_path__ + "static/media/payoff.61e8e756.svg";